<!-- =========================================================================================
  File Name: PageEdit.vue
  Description: Page Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Edit Floor Map</h3>
    </div>

    <vx-card v-if="page_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Floormap" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <form-fields class="mt-4" :data="page_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FormFields from "./FormFields.vue";

// Store Module
import moduleFloorMapManagement from "@/store/floormap-management/moduleFloorMapManagement.js";

export default {
  components: {
    FormFields,
  },
  data() {
    return {
      page_data: null,
      page_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetchFloorMap(this.$route.params.id);
    }
  },
  methods: {
    fetchFloorMap(id) {
      this.$store
        .dispatch("floorMapManagement/fetchFloorMap", id)
        .then(res => {
          this.page_data = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.page_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  created() {
    debugger;
    // Register Module UserManagement Module
    if (!moduleFloorMapManagement.isRegistered) {
      this.$store.registerModule("floorMapManagement", moduleFloorMapManagement);
      moduleFloorMapManagement.isRegistered = true;
    }
    this.fetchFloorMap(this.$route.params.id);
  }
};
</script>